import React, { useState } from 'react';
import { db } from '../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import './ResenaModal.css'; // Assuming you'll create this CSS file

function ReviewFormModal({ isOpen, onClose, onSubmit }) {
  const [author, setAuthor] = useState('');
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    if (!author || !rating || !comment) {
      setMessage('Por favor, completa todos los campos.');
      setLoading(false);
      return;
    }

    try {
      await addDoc(collection(db, 'reviews'), {
        author,
        rating,
        comment,
        createdAt: serverTimestamp(),
        status: 'pending', // Reviews will be pending approval
      });
      setMessage('¡Gracias por tu reseña! Será publicada después de ser aprobada.');
      setAuthor('');
      setRating(0);
      setComment('');
      onSubmit(); // Notify parent component of submission
    } catch (error) {
      console.error("Error submitting review: ", error);
      setMessage('Error al enviar la reseña. Por favor, inténtalo de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="resena-modal-overlay" onClick={onClose}>
      <div className="resena-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>&times;</button>
        <h2>Deja tu Reseña</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="author">Tu Nombre:</label>
            <input
              type="text"
              id="author"
              value={author}
              onChange={(e) => setAuthor(e.target.value)}
              disabled={loading}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="rating">Tu Calificación:</label>
            <div className="star-rating-input">
              {[1, 2, 3, 4, 5].map((star) => (
                <span
                  key={star}
                  className={`star ${star <= rating ? 'filled' : ''}`}
                  onClick={() => setRating(star)}
                  style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
                >
                  ★
                </span>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="comment">Tu Comentario:</label>
            <textarea
              id="comment"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              disabled={loading}
              required
            ></textarea>
          </div>
          <button type="submit" disabled={loading} className="submit-review-button">
            {loading ? 'Enviando...' : 'Enviar Reseña'}
          </button>
          {message && <p className="form-message" style={{ color: message.includes('Error') ? 'red' : 'green' }}>{message}</p>}
        </form>
      </div>
    </div>
  );
}

export default ReviewFormModal;
